module.exports = __webpack_public_path__ + "img/sigelei.ae321c0b.png";